import { QuestionFormat, QuestionTypePreset } from './enums.js';
/**
 * The 8 documented EPS-TOPIK/UBT question types (see
 * docs/superpowers/specs/2026-08-10-admin-question-authoring-ui-design.md
 * in the eps-koran-prep repo). This is the single source of truth for what
 * each type requires — both the server validator (question.model.ts) and
 * the admin UI (apps/admin/src/lib/questionPresets.ts) import it, so they
 * cannot drift apart.
 *
 * FILL_BLANK_TEXT and PARAGRAPH_TEXT are intentionally data-identical —
 * they exist as separate presets purely for their authoring placeholder
 * copy, not a stored distinction (see the design spec's Component
 * structure section).
 */
export const QUESTION_TYPE_PRESETS = [
    {
        id: QuestionTypePreset.AUDIO_PICTURE_AUDIO,
        label: 'Audio + Picture Q → Audio A',
        stem: { text: true, image: true, audio: true },
        optionFormat: QuestionFormat.AUDIO,
    },
    {
        id: QuestionTypePreset.AUDIO_AUDIO,
        label: 'Audio Q → Audio A',
        stem: { text: false, image: false, audio: true },
        optionFormat: QuestionFormat.AUDIO,
    },
    {
        id: QuestionTypePreset.AUDIO_IMAGE,
        label: 'Audio Q → Image A',
        stem: { text: true, image: false, audio: true },
        optionFormat: QuestionFormat.IMAGE,
    },
    {
        id: QuestionTypePreset.AUDIO_TEXT,
        label: 'Audio Q → Text A',
        stem: { text: true, image: false, audio: true },
        optionFormat: QuestionFormat.TEXT,
    },
    {
        id: QuestionTypePreset.FILL_BLANK_TEXT,
        label: 'Fill in the Blanks → Text A',
        stem: { text: true, image: false, audio: false },
        optionFormat: QuestionFormat.TEXT,
    },
    {
        id: QuestionTypePreset.PARAGRAPH_TEXT,
        label: 'Paragraph Q → Text A',
        stem: { text: true, image: false, audio: false },
        optionFormat: QuestionFormat.TEXT,
    },
    {
        id: QuestionTypePreset.PICTURE_TEXT,
        label: 'Picture Q → Text A',
        stem: { text: true, image: true, audio: false },
        optionFormat: QuestionFormat.TEXT,
    },
    {
        id: QuestionTypePreset.WORD_IMAGE,
        label: 'Word Q → Image A',
        stem: { text: true, image: false, audio: false },
        optionFormat: QuestionFormat.IMAGE,
    },
];
export const QUESTION_TYPE_PRESET_MAP = Object.fromEntries(QUESTION_TYPE_PRESETS.map((preset) => [preset.id, preset]));
//# sourceMappingURL=questionTypePresets.js.map